import { render, staticRenderFns } from "./HealthInformation.vue?vue&type=template&id=171ce36c&scoped=true"
import script from "./HealthInformation.vue?vue&type=script&lang=ts"
export * from "./HealthInformation.vue?vue&type=script&lang=ts"
import style0 from "./HealthInformation.vue?vue&type=style&index=0&id=171ce36c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ce36c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171ce36c')) {
      api.createRecord('171ce36c', component.options)
    } else {
      api.reload('171ce36c', component.options)
    }
    module.hot.accept("./HealthInformation.vue?vue&type=template&id=171ce36c&scoped=true", function () {
      api.rerender('171ce36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/ClientProfileSteps/HealthInformation.vue"
export default component.exports